<div class="flex gap-2 items-center p-1">
  <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>

  <span [innerHTML]="message" class="text-white"></span>
</div>
